var EventEmitter = require("events");
module.exports = new EventEmitter();



//////////////////
// WEBPACK FOOTER
// (webpack)/hot/emitter.js
// module id = ./node_modules/webpack/hot/emitter.js
// module chunks = 1